import { render, staticRenderFns } from "./h-gaps.vue?vue&type=template&id=0841b138&scoped=true"
import script from "./h-gaps.vue?vue&type=script&lang=js"
export * from "./h-gaps.vue?vue&type=script&lang=js"
import style0 from "./h-gaps.vue?vue&type=style&index=0&id=0841b138&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0841b138",
  null
  
)

export default component.exports